<template>
    <img
        :src="path"
        :width="width"
        :content="country ? country.name_fr : code"
        v-tippy
    />
</template>

<script>
export default {
    props: {
        code: {
            type: String,
            default: null,
        },

        country: {
            type: Object,
            default: () => {},
        },

        width: {
            type: [String, Number],
            default: 15,
        },
    },

    computed: {
        path() {
            var code = this.country ? this.country.alpha2 : this.code;

            code = code.toLowerCase();

            return "/images/flags/" + code + ".svg";
        },
    },
};
</script>
